import React from "react";

export const Page404 = () => {
  return (
    <div>
      <h1>ページが見つかりません</h1>
    </div>
  );
};
